import { render, staticRenderFns } from "./HrDashboard.vue?vue&type=template&id=0f9c521c&scoped=true"
import script from "./HrDashboard.vue?vue&type=script&lang=js"
export * from "./HrDashboard.vue?vue&type=script&lang=js"
import style0 from "./HrDashboard.vue?vue&type=style&index=0&id=0f9c521c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c521c",
  null
  
)

export default component.exports